module.exports = __webpack_public_path__ + "static/media/kyriakos-bg-image.d581b191.jpg";